import { render, staticRenderFns } from "./inside.vue?vue&type=template&id=28aab8e8&"
import script from "./inside.vue?vue&type=script&lang=js&"
export * from "./inside.vue?vue&type=script&lang=js&"
import style0 from "./inside.vue?vue&type=style&index=0&id=28aab8e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports